import * as DateF from 'date-fns'

import { Tooltip } from '@blade/ui-kit'
import { usePairAgeFormatted, type Pair } from '@root/entities/pair'
import { DATE_FORMAT } from '@root/shared'

import { TextCell } from './explore-text-cell'

type Props = {
  pair: Pair.PairMinimal
}

export const ExploreTableCreatedCell: React.FC<Props> = ({ pair }) => {
  const { formatted: pairAge } = usePairAgeFormatted(pair.createdAt)

  const renderTooltipContent = () => {
    if (!pair.createdAt) {
      return undefined
    }
    return DateF.format(pair.createdAt, DATE_FORMAT.HH_mm__dd_MM_yy)
  }

  return (
    <Tooltip content={renderTooltipContent()}>
      <TextCell>{pairAge || 'n/a'}</TextCell>
    </Tooltip>
  )
}
